<template lang="html">
  <header id="header">

    <div class="header-container">
      <b-navbar toggleable="lg" type="light" variant="light">
        <div class="container oversized-container">

          <b-navbar-brand to="/">
            <img src="public/images/logo.svg" class="img-fluid" alt="ESLOWINDOWS">
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <div class="col-12 box-extra-info">
              <div class="box-blank">
                </div>
              <div class="box-txt">
                <p>{{ $t("shared.titles.cita") }}:</p>
              </div>

              <div class="box-contact">
                <div class="img">
                  <img class="img-fluid rounded-circle" src="public/images/shared/person-1.jpg">
                </div>
                <div class="phone">
                  801 759 5815
                </div>
              </div>
              <div class="box-blank">
                </div>

              <!-- <div class="box-contact">
                <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url(public/images/shared/person-2.jpg)' }"></div>
                <div class="phone">
                  801 759 5815
                </div>
              </div> -->

              <div class="box-social">
                <!-- <a href="#"><i class="fab fa-twitter"></i></a> -->
                <a target="_blank" href="https://www.facebook.com/profile.php?id=61566874502482&mibextid=LQQJ4d&mibextid=LQQJ4d"><i class="fab fa-facebook-f"></i></a>
                <a target="_blank" href="https://www.instagram.com/eslo_usa/profilecard/?igsh=MXd6czIwZWVwZnZxZw=="><i class="fab fa-instagram"></i></a>
                <a href="mailto:contacto@eslowindows.com"><i class="fas fa-envelope"></i></a>
                <!--a data-fancybox data-width="640" data-height="360" href="public/images/pages/about-us/empresa.mp4" class="text-primary">► <small class="breadcrumb-item">MIRA NUESTRO VIDEO</small></a-->
                <a data-fancybox data-width="640" data-height="360" target="_blank" :href="'https://www.youtube.com/embed/'+video" class="btn btn-primary"><span class="mr-1">►</span><small class="text-light">{{ $t("shared.titles.video") }}</small></a>

                <!-- <span>
                  <a class="c-pointer btn-lang" v-bind:class="{ active : $i18n.locale == 'en' }" @click="$root.changeLangBTN('en')">ENG</a>
                  <a class="sep">|</a>
                  <a class="c-pointer btn-lang" v-bind:class="{ active : $i18n.locale == 'es' }" @click="$root.changeLangBTN('es')">ESP</a>
                </span>  -->
              </div>
            </div>

            <div class="row box-menu">
              <b-navbar-nav>
                <b-nav-item to="/">{{ $t("shared.titles.home") }}</b-nav-item>

                <b-nav-item to="/productos">{{ $t("shared.titles.products") }}</b-nav-item>
                <b-nav-item to="/proyectos">{{ $t("shared.titles.projects") }}</b-nav-item>
                <!-- <b-nav-item to="/testimonios">Testimonios</b-nav-item> -->
                <b-nav-item to="/distribuidores">{{ $t("shared.titles.dealers") }}</b-nav-item>
                <b-nav-item to="/empresa">{{ $t("shared.titles.company") }}</b-nav-item>
                <b-nav-item to="/garantias">{{ $t("shared.titles.warranties") }}</b-nav-item>
                <b-nav-item to="/contacto">{{ $t("shared.titles.contact") }}</b-nav-item>
                <!--b-nav-item to="/cotizador">Cotizador</b-nav-item-->
                <b-nav-item to="/galeria">{{ $t("shared.titles.gallery") }}</b-nav-item>
                <!-- <li class="li-langs">
                  <a class="btn-lang" v-bind:class="{ active : $i18n.locale == 'en' }" @click="$root.changeLangBTN('en')">ENG</a>
                  <span class="sep">|</span>
                  <a class="btn-lang" v-bind:class="{ active : $i18n.locale == 'es' }" @click="$root.changeLangBTN('es')">ESP</a>
                </li> -->
                <li class="videoMenu"><a data-fancybox data-width="640" data-height="360" :href="'https://www.youtube.com/embed/'+video" class="btn btn-primary"><span class="breadcrumb-item">► </span><small class="text-light">{{ $t("shared.titles.video") }}</small></a></li>
              </b-navbar-nav>
            </div>
          </b-collapse>

        </div>
      </b-navbar>
    </div>

  </header>
</template>

<script>
export default {
    data() {
        return {
          video:""
        }
    },
    methods: {
        getVideo: function(){
        axios.get(tools.url('/videoheader')).then(
          ({data}) =>{
            this.video=data;
          });
        },
    },
    mounted() {
      this.getVideo();
    }
}
</script>
